import { Directive, inject, TemplateRef } from '@angular/core';

interface Context {
  $implicit: any;
}

@Directive({
  selector: '[scFilteredSelectOption]',
  standalone: false
})
export class FilteredSelectOptionDirective {
  template = inject<TemplateRef<any>>(TemplateRef);

  static ngTemplateContextGuard(dir: FilteredSelectOptionDirective, ctx: any): ctx is Context {
    return true;
  }
}
